module.exports = __webpack_public_path__ + "media/images/competitions/home_promo-55abe9173ee0a75abc29800efb9276a7.png";